import React, { useState, useEffect } from 'react';
import { APIUrl } from './APIUrl';

const Token = JSON.parse(localStorage.getItem('tcn'));


const GetStates = () => {
    const [states, setStates] = useState([]);

    useEffect(() => {
        const getAllState = async () => {
            try {
                const response = await fetch(APIUrl.State + 'GetAllState', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${Token}`
                    }
                });

                const result = await response.json();
                if (result && result.data !== null) {
                    setStates(result.data);
                }
            } catch (error) {
                console.log(error);
            }
        };

        getAllState();
    }, []);

    return states;
};

const GetCities = (stateId) => {
    const [cities, setCities] = useState([]);

    useEffect(() => {
        const getCitiesByStateId = async () => {
            try {
                if (!stateId || stateId === '0') {
                    setCities([]);
                    return;
                }

                const response = await fetch(APIUrl.Cities + `GetCitiesByStateId/${stateId}`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${Token}`
                    },
                    body: JSON.stringify()
                });

                const result = await response.json();
                if (result && result.data !== null) {
                    setCities(result.data);
                }
            } catch (error) {
                console.log(error);
            }
        };

        getCitiesByStateId();
    }, [stateId]);

    return cities;
}

const GetAllAmenities = async () => {
    try {
        const response = await fetch(APIUrl.SZType + 'GetSZTypeBySectionId/1', {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${Token}`
            },
            body: JSON.stringify()
        });
        const result = await response.json();
        if (result.data !== null) {
            return result.data;
        }
    } catch (error) {
        console.log(error);
    }
};

const GetAllPropertyStatus = async () => {
    try {
        const response = await fetch(APIUrl.SZType + 'GetSZTypeBySectionId/2', {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${Token}`
            },
            body: JSON.stringify()
        });
        const result = await response.json();
        if (result.data !== null) {
            return result.data;
        }
    } catch (error) {
        console.log(error);
    }
};

const GetAllPropertyTypes = async () => {
    try {
        const response = await fetch(APIUrl.SZType + 'GetSZTypeBySectionId/3', {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${Token}`
            },
            body: JSON.stringify()
        });
        const result = await response.json();
        if (result.data !== null) {
            return result.data;
        }
    } catch (error) {
        console.log(error);
    }
};

const GetAllNoofBedrooms = async () => {
    try {
        const response = await fetch(APIUrl.SZType + 'GetSZTypeBySectionId/4', {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${Token}`
            },
            body: JSON.stringify()
        });
        const result = await response.json();
        if (result.data !== null) {
            return result.data;
        }
    } catch (error) {
        console.log(error);
    }
};

const GetAllNoofBathrooms = async () => {
    try {
        const response = await fetch(APIUrl.SZType + 'GetSZTypeBySectionId/5', {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${Token}`
            },
            body: JSON.stringify()
        });
        const result = await response.json();
        if (result.data !== null) {
            return result.data;
        }
    } catch (error) {
        console.log(error);
    }
};

const GetAllConstructionStatus = async () => {
    try {
        const response = await fetch(APIUrl.SZType + 'GetSZTypeBySectionId/6', {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${Token}`
            },
            body: JSON.stringify()
        });
        const result = await response.json();
        if (result.data !== null) {
            return result.data;
        }
    } catch (error) {
        console.log(error);
    }
};

const GetAllPostedBy = async () => {
    try {
        const response = await fetch(APIUrl.SZType + 'GetSZTypeBySectionId/7', {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${Token}`
            },
            body: JSON.stringify()
        });
        const result = await response.json();
        if (result.data !== null) {
            return result.data;
        }
    } catch (error) {
        console.log(error);
    }
};

const GetAllSZTypeforWeb = async () => {
    try {
        const response = await fetch(APIUrl.SZType + 'GetAllSZTypeforWeb', {
            method: "POST",
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify()
        });
        const result = await response.json();
        if (result.data !== null) {
            let filterdata = result.data.filter(item => item.IsActive == true && item.SectionId == 11 || item.SectionId == 12);
            filterdata.unshift({ TypeId: 0, TypeName: "Select Property Type", SectionId: 0 });
            return filterdata;
        }
    } catch (error) {
        console.log(error);
    }
};




export {
    GetStates,
    GetCities,
    GetAllAmenities,
    GetAllPropertyStatus,
    GetAllPropertyTypes,
    GetAllNoofBedrooms,
    GetAllNoofBathrooms,
    GetAllConstructionStatus,
    GetAllPostedBy,
    GetAllSZTypeforWeb
};

export const MasterAPIHelper = {
    GetStates,
    GetCities,
    GetAllAmenities,
    GetAllPropertyStatus,
    GetAllPropertyTypes,
    GetAllNoofBedrooms,
    GetAllNoofBathrooms,
    GetAllConstructionStatus,
    GetAllPostedBy,
    GetAllSZTypeforWeb
}

